// extracted by mini-css-extract-plugin
export default {"dialog__content":"AddToolsPopup_dialog__content__NG+w1","dialog__tools":"AddToolsPopup_dialog__tools__SO2hy"};